import {
  EMAIL_TEMPLATES_SET_USER_FOLDERS,
  EMAIL_TEMPLATES_SET_SHARED_FOLDERS,
  EMAIL_TEMPLATES_SET_SELECTED_FOLDER,
  EMAIL_TEMPLATES_SET_EDIT_FOLDERS,
  EMAIL_TEMPLATES_SET_FOLDERS_ORDER,
  EMAIL_TEMPLATES_UPDATE_FOLDER_NAME,
  EMAIL_TEMPLATES_CREATE_EDIT_FOLDERS,
  EMAIL_TEMPLATES_DELETE_EDIT_FOLDERS,
  EMAIL_TEMPLATES_SET_DELETED_FOLDERS
} from './actionType';

// Set User Folders
export const setUserFolderData = userFolders => ({
  type: EMAIL_TEMPLATES_SET_USER_FOLDERS,
  userFolders
});

// Set Shared Folders
export const setSharedFolderData = sharedFolders => ({
  type: EMAIL_TEMPLATES_SET_SHARED_FOLDERS,
  sharedFolders
});

export const setSelectedFolder = selectedFolder => ({
  type: EMAIL_TEMPLATES_SET_SELECTED_FOLDER,
  selectedFolder
});

// Set edited Folders
export const setEditFolderData = editFolders => ({
  type: EMAIL_TEMPLATES_SET_EDIT_FOLDERS,
  editFolders
});

export const setDeletedFolderData = ids => ({
  type: EMAIL_TEMPLATES_SET_DELETED_FOLDERS,
  ids
});

// Delete User Folders
export const deleteEditFolderData = id => ({
  type: EMAIL_TEMPLATES_DELETE_EDIT_FOLDERS,
  id
});

export const setNewOrder = payload => ({
  type: EMAIL_TEMPLATES_SET_FOLDERS_ORDER,
  payload
});

export const updateFolderName = ({ id, name }) => ({
  type: EMAIL_TEMPLATES_UPDATE_FOLDER_NAME,
  payload: { id, name }
});

export const createEditFolder = payload => ({
  type: EMAIL_TEMPLATES_CREATE_EDIT_FOLDERS,
  payload
});



// WEBPACK FOOTER //
// ./src/views/email/emailTemplates/flow/folderFlow/action.js